<template>
	<!-- 仅包含路由视图，没有其他公共组件 -->
	<router-view />
</template>

<script>
export default {
	name: 'blankLayout'
}
</script>